/* globals $:false */

import tmpl from '../templates/definition-condition-list.dot';

// View to edit a Field's condition list
//
// callbacks:
//
//  * `top_field_add`: Called when the user wants to add a field to the top
//  * `top_field_drop`: Called when the user drops a field in the top spot
//  * `bottom_condition_add`: Called when the user wants to add a condition to the bottom of the list
var DefinitionFieldConditionListV = function(core, $container, field, callbacks){
    var _$element = {};
    var _$fieldInsertionPoint;
    var _$conditionInsertionPoint;

    return{
        build: function() {
            _$element = $(tmpl(field));

            _$fieldInsertionPoint = _$element.find("li.field-insertion-point");
            _$conditionInsertionPoint = _$element.find("li.condition-insertion-point");

            _$fieldInsertionPoint.on('click', callbacks.top_field_add);
            _$fieldInsertionPoint.droppable({
                //class added to the element while something is beeing dragged
                activeClass: 'def-state-active',

                //class added to the elemente while something is hovering above it
                hoverClass: 'def-state-hover',

                // don't add the dropped element to parent droppables
                greedy: true,

                // called when the element is actually dropped
                drop: function(event, ui) {
                    var _$draggedElement = ui.draggable;
                    //para a li voltar à lista e não ficar com o offset do fim do drag
                    _$draggedElement.attr('style', 'position:relative;');

                    callbacks.top_field_drop(_$draggedElement);
                }
            });

            _$conditionInsertionPoint.on('click', callbacks.bottom_condition_add);

            $container.append(_$element);
        },

        addTopField: function(fieldP) {
            _$fieldInsertionPoint.after(fieldP.content());

            fieldP.focus();
        },

        addBottomCondition: function(condP) {
            _$conditionInsertionPoint.before(condP.content());

            condP.focus();
        },

        getContainer: function() {
            return _$element;
        }
    }

};

export default DefinitionFieldConditionListV;
